// component
import SignUpProjectListCom from './sign-up-project-list/sign-up-project-list.vue';
import MarginPaymentCom from './margin-payment/margin-payment.vue';
import SignUpProjectDetailCom from './sign-up-project-detail/sign-up-project-detail.vue';

export default [
  {
    path: 'list',
    name: 'signUpProjectList',
    component: SignUpProjectListCom,
    meta: {
      title: '报名流传标的',
      breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'margin-payment',
    name: 'marginPayment',
    component: MarginPaymentCom,
    meta: {
      title: '支付保证金',
      breadCrumbShowIndexArr: [0, 2, 3]
    }
  },
  {
    path: 'detail',
    name: 'signUpProjectDetail',
    component: SignUpProjectDetailCom,
    meta: {
      title: '报名详情',
      breadCrumbShowIndexArr: [0, 2, 3]
    }
  }
];

